<template>
    <CieloLayout>
        <div class="check-otp" tabindex="-1">
            <h4
                class="check-otp__title"
                v-text="$ml.get('titleCheckOtp')"
                tabindex="0"
            />
            <div class="check-otp__inputs-container">
                <CheckCodeOtp
                    ref="checkCodeOtp"
                    :email="customerEmail"
                    :error="error"
                    :attempt-count="otpAttempts"
                    :max-attempts="maxAttempts"
                    :is-verifying="isVerifying"
                    @verify="verifyOtp"
                    @resend="sendOtp"
                    @verifying="isVerifying = $event"
                />
            </div>
        </div>
        <button
            class="check-otp__button"
            :disabled="isVerifying"
            @click="goToNextStep"
        >
            <span v-text="$ml.get('otpGuest')" />
        </button>
    </CieloLayout>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import CheckCodeOtp from '@/components/DataOnFile/CheckCodeOtp';
import CieloLayout from '@/components/layout/CieloLayout';

export default {
	components: {
		CieloLayout,
		CheckCodeOtp,
	},

	data() {
		return {
			isOtpVerified: false,
			isVerifying: false,
			error: false,
			errorMessage: '',
			maxAttempts: 3,
		};
	},

	computed: {
		...mapGetters({
			customerEmail: 'customer/getEmail',
		}),
		...mapState('dataOnFile', ['otpAttempts']),
	},

	mounted() {
		this.$validator.validate();
	},

	methods: {
		async sendOtp() {
			this.isVerifying = true;
			try {
				await this.$store.dispatch(
					'dataOnFile/sendOtp',
					this.customerEmail
				);
			} catch (error) {
				this.error = true;
				this.errorMessage = error.message || 'Erro ao enviar OTP.';
			} finally {
				this.isVerifying = false;
			}
		},

		async verifyOtp(userOtp) {
			this.isVerifying = true;
			this.error = false;
			this.errorMessage = '';
			try {
				await this.$store.dispatch('dataOnFile/verifyOtp', {
					email: this.customerEmail,
					otp: userOtp,
				});
				this.isOtpVerified = true;
				await this.$store.dispatch('pipelineV2/pushNext');
			} catch (error) {
				this.error = true;
				this.errorMessage =
					error.message || 'Erro ao verificar o código OTP.';
				this.$refs.checkCodeOtp.clearOtp();
			} finally {
				this.isVerifying = false;
			}
		},

		async goToNextStep() {
			this.$store.commit('dataOnFile/clearDofSession');
			await this.$store.dispatch('pipelineV2/pushNext');
		},
	},
};
</script>

<style lang="scss" scoped>
.check-otp {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	flex: 1 0 auto;

	&__title {
		width: 100%;
		max-width: 328px;
		display: block;
		font-size: 20px;
		font-weight: 700;
		line-height: 28px;
		color: #2f363e;
		margin-bottom: 20px;

		@media screen and (min-width: 768px) {
			width: 100%;
			max-width: initial;
		}
	}

	&__inputs-container {
		width: 100%;

		@media screen and (min-width: 768px) {
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;
			justify-content: space-between;
		}
	}

	&__button {
		width: 100%;

		display: flex;
		justify-content: center;
		align-items: center;

		background: none;
		border: none;

		font-size: 16px;
		font-weight: 600;
		color: #0774e7;

		&:disabled {
			height: 44px;
			font-size: 16px;
			font-weight: 600;
			color: #2f363e;
			padding: 16px 20px;
			background-color: #eff1f3;
			border: 1.5px solid transparent;
			border-radius: 32px;
			cursor: not-allowed;
		}
	}
}
</style>
